(function () {
    const ID = 'FE-4003';

    function init() {
        window['feHPEB2C'].log('4003-product-line-filter-order init()');

        var list = ['Aruba', 'OfficeConnect', 'FlexFabric', 'Altoline', 'Composable', 'FlexNetwork', 'Arista'];
        var listOld = $(`section.${ID}__product-line-filter li.hpe-filter__item`);
        var listNew = [];
        list.forEach(function (item) {
            $(listOld).each(function (index) {
                var _this = this;
                var label = $(this).find('.facet__list__text').text();
                label = label.replace(/&nbsp;/gi, '');
                label = label.replace(/(\r\n|\n|\r)/gm, ' ');
                label = label.trim();
                var listNamesOld = label.split(' ');
                var nameOld = listNamesOld[0].trim()
                var nameNew = item.trim()

                if (nameNew === nameOld) {
                    listNew.push($(_this));
                }
            });

        });
        $('section.FE-4003__product-line-filter ul.hpe-filter__list').append(listNew);
    }
    if (feHPEB2C.doesUrlMatch(["networking/c/12883", "networking/switches/c/4172267"])) {
        const arubaInputElem = document.querySelector('[data-analytics-filtervalue="Aruba"]');

        window.feUtils.waitForConditions({
            conditions: [
                'body',
                () => arubaInputElem
            ],
            activity: feProjectId,
            callback: () => {
                    const filterSection = arubaInputElem?.closest('section.hpe-disclosure__section')
                    filterSection.classList.add(`${ID}__product-line-filter`);

                    init();
            }
        });
    }
})();
